import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { api } from '../services/api';
import { Shield, Eye, EyeOff, ArrowLeft } from 'lucide-react';

export const AdminLoginPage: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const { loginAdmin } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const res = await api.loginAdmin(email.trim(), password);
      if (res.success && res.admin && res.token) {
        loginAdmin(res.admin, res.token);
        navigate('/admin/dashboard');
      } else {
        setError(res.message || 'Invalid administrator credentials.');
      }
    } catch (err: any) {
      setError(err.message || 'Authentication error.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        backgroundColor: '#171619',
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '24px',
        color: '#FFFFFF',
      }}
    >
      <div style={{ maxWidth: '420px', width: '100%' }}>
        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
          <img
            src="/assets/images/electpoll logo (plain white).png"
            alt="Electpoll"
            style={{ height: '44px', marginBottom: '16px' }}
          />
          <h1 style={{ fontSize: '24px', fontWeight: 800 }}>Admin Portal</h1>
          <p style={{ fontSize: '13px', color: '#8E8E93', marginTop: '6px' }}>
            Multi-election management & demographic intelligence
          </p>
        </div>

        <div
          style={{
            backgroundColor: '#1E1D21',
            borderRadius: '20px',
            border: '1px solid #2D2C31',
            padding: '36px 32px',
            boxShadow: '0 20px 40px rgba(0,0,0,0.5)',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '24px' }}>
            <Shield size={20} color="#FF9900" />
            <span style={{ fontSize: '14px', fontWeight: 700, color: '#FFFFFF' }}>
              Electoral Officer Sign In
            </span>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="input-group dark">
              <label>Administrator Email</label>
              <input
                type="email"
                className="input-field dark"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter administrator email"
                autoComplete="username"
                required
              />
            </div>

            <div className="input-group dark">
              <label>Password</label>
              <div style={{ position: 'relative' }}>
                <input
                  type={showPassword ? 'text' : 'password'}
                  className="input-field dark"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Enter administrator password"
                  autoComplete="current-password"
                  style={{ width: '100%', paddingRight: '44px' }}
                  required
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  style={{
                    position: 'absolute',
                    right: '12px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    background: 'none',
                    border: 'none',
                    color: '#8E8E93',
                    cursor: 'pointer',
                  }}
                >
                  {showPassword ? <EyeOff size={16} /> : <Eye size={16} />}
                </button>
              </div>
            </div>

            {error && (
              <div style={{ color: '#EF4444', fontSize: '13px', fontWeight: 600, marginBottom: '16px' }}>
                *{error}
              </div>
            )}

            <button type="submit" className="btn-primary" disabled={loading} style={{ height: '48px', fontSize: '15px' }}>
              {loading ? 'Authenticating...' : 'Access Dashboard'}
            </button>
          </form>
        </div>

        <div style={{ textAlign: 'center', marginTop: '24px' }}>
          <Link to="/" style={{ color: '#8E8E93', fontSize: '13px', display: 'inline-flex', alignItems: 'center', gap: '6px' }}>
            <ArrowLeft size={14} /> Back to Public Portal
          </Link>
        </div>
      </div>
    </div>
  );
};
